"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MGEOAPI = void 0;
const apisauce_1 = __importDefault(require("apisauce"));
const BaseAPI_1 = __importStar(require("./BaseAPI"));
class MGEOAPI {
    static setup(config, options) {
        MGEOAPI.instance = BaseAPI_1.default.getInstance(config, options);
    }
    static async get(args) {
        return BaseAPI_1.default.get(MGEOAPI.instance, args);
    }
    static async post(args) {
        if (!MGEOAPI.instance) {
            throw new BaseAPI_1.ApiError('not_setup');
        }
        const { url, body, headers, onUploadProgress, cancelToken } = args;
        BaseAPI_1.default.setHeaders(MGEOAPI.instance, headers);
        const response = await MGEOAPI.instance.post(url, body, {
            onUploadProgress,
            cancelToken
        });
        return MGEOAPI.returnResponse(response);
    }
    static returnResponse(response) {
        if (!response.ok && response.problem) {
            const data = response.data;
            const error = response && data && (data.title || data.message)
                ? data.title || data.message
                : response && response.originalError && response.originalError.message;
            return Promise.reject({
                message: error,
                payload: response.data,
                Headers: response.headers
            });
        }
        return { data: response.data, headers: response.headers };
    }
    static async put(args) {
        return BaseAPI_1.default.put(MGEOAPI.instance, args);
    }
    static async delete(args) {
        return BaseAPI_1.default.delete(MGEOAPI.instance, args);
    }
    static reset() {
        return BaseAPI_1.default.reset(MGEOAPI.instance);
    }
    static createCancelToken() {
        return apisauce_1.default.CancelToken.source();
    }
}
exports.MGEOAPI = MGEOAPI;
MGEOAPI.instance = undefined;
//# sourceMappingURL=mgeo-api.js.map